import React from "react";
import { Col, Form } from "react-bootstrap";
import useSkills from "../../hooks/useSkills";

// The crew skill picker shared by Add, Attach and Edit crew. The options and
// their wording come from the backend skill metadata for the vendor's industry
// (useSkills), never from an inline industry ternary, and it renders NOTHING when
// there is no choice to make - so a vendor whose industry offers one skill, or an
// API that has not been given the skills migration yet, sees the screen as before.
//
//   value     the skill key; blank means the industry's default skill
//   onChange  called with the new skill key
//   colMd     when set the picker is wrapped in a <Col md=...> (grid forms)
//   disabled  e.g. a crew member viewing their own profile
export default function SkillSelect({ value, onChange, colMd, disabled, label = "Skill", className = "" }) {
  const { skills, offersChoice } = useSkills();
  if (!offersChoice) return null;

  const defaultKey = (skills.find((s) => s.is_default) || skills[0]).skill_key;
  const group = (
    <Form.Group className={className}>
      <Form.Label>{label}</Form.Label>
      <Form.Select
        aria-label={label}
        value={value || defaultKey}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
      >
        {skills.map((s) => (
          <option key={s.skill_key} value={s.skill_key}>
            {s.label}
          </option>
        ))}
      </Form.Select>
    </Form.Group>
  );
  return colMd ? <Col md={colMd}>{group}</Col> : group;
}
